import { render } from "./DatePicker.vue?vue&type=template&id=463f3a26"
import script from "./DatePicker.vue?vue&type=script&lang=js"
export * from "./DatePicker.vue?vue&type=script&lang=js"
script.render = render

export default script